import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { withRouter } from "common/utils/router.util";
import { withStyles } from '@mui/styles';

function LinearProgressWithLabel({ progress = 0, totalProgress = 1, message = '', type = 'percentage', ...linearProgressProps }) {
  
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress 
          variant="determinate" 
          {...linearProgressProps} 
          value={type === 'normal' ? (Math.ceil((progress/totalProgress)*100)) : progress} 
        />
      </Box>
      <Box style={{ width: '15%' }}>
        <Typography variant="subtitle2" color="primary">{`${type === 'normal' ? progress : `${Math.ceil(
          progress,
        )}%`} ${message ? message : ``}`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  progress: PropTypes.number.isRequired,
  totalProgress: PropTypes.number.isRequired,
  message: PropTypes.any,
  type: PropTypes.oneOf(['normal', 'percentage']),
};

// defaultProps removed in favor of default parameters

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
});

export default function LinearWithValueLabel(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgressWithLabel {...props} />
    </div>
  );
}
